export enum MatchOfferRejectionReason {    
    VirtualMatchFailure = 1,
    DonorNotAcceptable = 2,
    RecipientAlreadyTransplanted = 3,
    RecipientInAlternateSwap = 4,
    RecipientIsSick = 5,
    DonorBackedOut = 6,
    DonorHasToWork = 7,
    DonorPregnant = 8,
    CannotAccommodateSurgeryDate = 9,
    Other = 10,
    DonorSafetyIssue = 11,
    PhysicalMatchFailure = 12
}